import React from 'react';
import PageTitle from '../components/pagetitle';
import CTA from '../components/cta';
import Section from '../components/section';
import Project from '../components/project/project_v3';
import Token from '../components/token/index';
import Partner3 from '../components/partner/Partner3';
import Project2 from '../components/project/project_v2';
import { vision, mission, valueProposition, platform, steps } from '../assets/fake-data/data-about';
import { dataPartners } from '../assets/fake-data/data-partner';
import dataSolution from '../assets/fake-data/data-solution';

function About(props) {
    return (
        <div className='inner-page'>
            <PageTitle title='Acerca de Nosotros' />
            <Section data={valueProposition} />
            <Section data={vision} />
            <Section data={mission} />
            <Project className='mb-3 mt-3' data={steps} title={'¿Por qué nos eligen?'} title_2={''} responsive={true} />
            <Project2 className='mb-3 mt-3' data={dataSolution} />
            <Token className='mb-3 mt-3' />
            <Partner3 className='mb-3 mt-3' data={dataPartners} />
            <Section className='mb-3 mt-3' data={platform} />
            <CTA />
        </div>
    );
}

export default About;